/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';

export default function MineralCredits({ data = {} }) {
  const { t } = useTranslation();

  return (
    <Widget
      className="with-border-header custom-width-b no-pb-body no-pt-body"
      title={t('Responsible Mineral Credits')}
    >
      <Style>
        <div className="credit-cont flex-1">
          <div className="credit-row">
            <div className="icon-cont mr-3">
              <img alt="icon" src="/assets/images/dashboard/programs/key-data.svg" />
            </div>
            <div className="text-cont">
              <h5>{t('Key Data')}</h5>
              <p>{data?.keyData || '--'}</p>
            </div>
          </div>
        </div>

        <div className="credit-cont flex-1">
          <div className="credit-row">
            <div className="icon-cont mr-3">
              <img alt="icon" src="/assets/images/dashboard/programs/key-projects.svg" />
            </div>
            <div className="text-cont">
              <h5>{t('Key Projects')}</h5>
              <p>{data?.keyProjects || '--'}</p>
            </div>
          </div>
        </div>
      </Style>
    </Widget>
  )
}
